module.exports = __webpack_public_path__ + "img/p2_l.2f006482.jpg";